import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

// Hoisted out of render so the inline-style object isn't rebuilt on every
// theme change. All values reference CSS vars, so identity is stable.
const TOASTER_STYLE: React.CSSProperties = {
  '--normal-bg': 'var(--bg-3)',
  '--normal-text': 'var(--paper)',
  '--normal-border': 'var(--line-bright)',
  '--success-bg': 'var(--bg-3)',
  '--success-text': 'var(--paper)',
  '--success-border': 'color-mix(in srgb, var(--acid) 35%, var(--line-bright))',
  '--error-bg': 'var(--alert-error-bg)',
  '--error-text': 'var(--alert-error-text)',
  '--error-border': 'var(--alert-error-border)',
  '--warning-bg': 'color-mix(in srgb, var(--warning) 8%, var(--bg-3))',
  '--warning-text': 'var(--alert-warning-text)',
  '--warning-border': 'color-mix(in srgb, var(--warning) 30%, var(--line-bright))',
  '--info-bg': 'var(--bg-3)',
  '--info-text': 'var(--paper-dim)',
  '--info-border': 'var(--line-bright)',
  '--border-radius': '9px',
} as React.CSSProperties

const TOASTER_ICONS = {
  success: <CircleCheckIcon className="size-4" />,
  info: <InfoIcon className="size-4" />,
  warning: <TriangleAlertIcon className="size-4" />,
  error: <OctagonXIcon className="size-4" />,
  loading: <Loader2Icon className="size-4 animate-spin" />,
}

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'dark' } = useTheme()
  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={TOASTER_ICONS}
      style={TOASTER_STYLE}
      {...props}
    />
  )
}

export { Toaster }
